import Vue from 'vue'
import VueRouter from 'vue-router'
//import Deals from '../views/Deals.vue'
import DealsLayout from '../views/DealsLayout.vue'
import Deal from '../views/Deal.vue'
import Companies from '../views/Companies.vue'
import Company from '../views/Company.vue'
import Contacts from '../views/Contacts.vue'
import Contact from '../views/Contact.vue'
import Tasks from '../views/Tasks.vue'
import TasksKanban from '../views/TasksKanban.vue'
import TasksWeek from '../views/TasksWeek.vue'
import Users from '../views/Users.vue'
import TelegramBot from '../views/TelegramBot.vue'
//import Login from '../views/Login.vue'
//import store from "../store";
//import VueJwtDecode from "vue-jwt-decode";

Vue.use(VueRouter);

const routes = [
  {path: '/', redirect: {name: 'Deals'}},
  {
    path: '/deals',
    name: 'Deals',
    component: DealsLayout,
    meta: {auth: true, title: 'Сделки', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/deals/:id',
    name: 'Deal',
    component: Deal,
    meta: {auth: true, title: 'Сделка', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
    meta: {auth: true, title: 'Контакты', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/contacts/:id',
    name: 'Contact',
    component: Contact,
    meta: {auth: true, title: 'Контакты', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/companies',
    name: 'Companies',
    component: Companies,
    meta: {auth: true, title: 'Компании', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/companies/:id',
    name: 'Company',
    component: Company,
    meta: {auth: true, title: 'Компания', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    meta: {auth: true, title: 'Задачи', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/tasks-kanban',
    name: 'TasksKanban',
    component: TasksKanban,
    meta: {auth: true, title: 'Задачи (Kanban)', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/tasks-week',
    name: 'TasksWeek',
    component: TasksWeek,
    meta: {auth: true, title: 'Задачи (неделя)', roles: ['ROLE_CRM', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {auth: true, title: 'Пользователи', roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
  {
    path: '/bot',
    name: 'TelegramBot',
    component: TelegramBot,
    meta: {auth: true, title: 'Телеграм бот', roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_URL_PREFIX,
  routes
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  if (nearestWithTitle)
    document.title = nearestWithTitle.meta.title;

  Array.from(document.querySelectorAll('[data-vue-router-controlled]'))
    .map(el => el.parentNode.removeChild(el));

  next();
});
router.afterEach((to, from) => {
  let msg = {
    'event': 'onNavigate',
    'data': {
      'from': from.fullPath,
      'to': to.fullPath,
    }
  };
  parent.postMessage(msg, '*');
})
/*
router.beforeEach((to, from, next) => {
    let userRoles = [];
    if (!store.getters.getTokenObj) {
        if (localStorage.auth_token) { // если vuex еще не создан но есть токен то заберем роли из него
            try {
                let tokenObj = VueJwtDecode.decode(localStorage.auth_token);
                userRoles = tokenObj.roles;
            } catch (e) {
                console.log(e);
            }
        }
    } else {
        userRoles = store.getters.getTokenObj ? store.getters.getTokenObj.roles : [];
    }

    if (userRoles.length > 0 && to.matched.some(record => record.meta.roles.filter(value => -1 !== userRoles.indexOf(value)).length === 0 && record.meta.roles.length > 0)) {
        // если роли в роуте и токене не совпадают то адресуем в первый роут для роли или в логин если вообще не найдено
        let redirectPath = '/login';
        userRoles.forEach(role => {
            router.options.routes.forEach(routeItem => {
                if (routeItem.meta.roles.includes(role)) {
                    //console.log(role, routeItem, routeItem.meta.roles.includes(role));
                    if (redirectPath === '/login')
                        redirectPath = routeItem.path;
                }
            })
        });
        next({path: redirectPath});
    } else {
        next();
    }
});
*/
export default router
